import { Box, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { ManageAccounts, Person } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { changeMainMember } from 'src/shared/services/familyService';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { useGlobals } from 'src/shared/contexts/appContext';
import { FamilyMemberNew } from '../models/familyMember';

type MemberFamilyChangeMainMemberModalProps = {
  modalOpen: boolean;
  onClose: () => void;
  member: FamilyMemberNew;
  successCallback: () => void;
};

export const MemberFamilyChangeMainMemberModal = (props: MemberFamilyChangeMainMemberModalProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { modalOpen, onClose, member, successCallback } = props;
  const { setDateStamp } = useGlobals();
  const { t } = useTranslation(['common']);
  const isMounted = useIsMounted();
  const [loading, setLoading] = useState(false);

  const onCloseHandler = () => {
    onClose();
  };

  const onHandleChange = async () => {
    setLoading(true);
    try {
      await changeMainMember(member.familymember_id);
      if (isMounted()) {
        toast.success(<>{t('member:family.changeMainMemberSuccess')}</>);
        setDateStamp(new Date());
      }
    } catch (error) {
      if (isMounted()) ConsoleHelper.log(error);
    } finally {
      if (isMounted()) setLoading(false);
    }
  };

  return (
    <GenericDialog
      open={modalOpen}
      onClose={onCloseHandler}
      onSave={() => ConsoleHelper.log('save')}
      maxWidth='xs'
      padding={0}
      dialogTitle={t('member:family.changeMemberTypeModalHeader')}
      dialogContent={
        <Box sx={{ p: 1 }}>
          <List dense>
            <ListItem sx={{ py: 0, pl: 0.5 }} key={member.member_id}>
              <ListItemIcon sx={{ width: '2rem', maxWidth: '2rem', minWidth: '2rem' }}>
                {member.mainMember && <ManageAccounts fontSize='small' />}
                {!member.mainMember && <Person fontSize='small' />}
              </ListItemIcon>
              <ListItemText
                primary={<Link to={`${RoutesEnum.MemberDetails}/${member.member_id}`}>{`${member.firstName} ${member.lastName}`}</Link>}
              />
            </ListItem>
          </List>
        </Box>
      }
      dialogActions={
        <Box display='flex' flexDirection='row' justifyContent='flex-end' width='100%'>
          <Button variant='outlined' sx={{ mr: 1 }} onClick={onCloseHandler}>
            {t('common:button.cancel')}
          </Button>
          <LoadingButton variant='contained' loading={loading} disableElevation onClick={onHandleChange}>
            {t('common:button.yes')}
          </LoadingButton>
        </Box>
      }
    />
  );
};
